import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SouffranceStep from './SouffranceStep';
import { CodeDepot } from 'constants.js';

class SouffranceStepContainer extends React.Component {

    render() {
        return (
            <SouffranceStep {...this.props} />
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let lignesUniquement = false;

    let piece = state.pieceGestion[ownProps.namespace].piecesGestion ? state.pieceGestion[ownProps.namespace].piecesGestion.items.find(p => p.numeroPiece === ownProps.reclamation.numeroPiece) : null;

    if (piece) {
        lignesUniquement = piece.codeDepot === CodeDepot.PlateformeVaulx;
    }

    return {
        lignesUniquement: lignesUniquement
    };
};


SouffranceStepContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    namespace: PropTypes.string.isRequired
};

export default connect(mapStateToProps, null)(SouffranceStepContainer);